import type { DashboardContentProps } from 'src/layouts/dashboard';

import { removeLastSlash } from 'minimal-shared/utils';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { paths } from 'src/routes/paths';
import { usePathname } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';

import { useTranslate } from 'src/locales';
import { DashboardContent } from 'src/layouts/dashboard';

import { Iconify } from 'src/components/iconify';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';

// ----------------------------------------------------------------------

export function AccountLayout({ children, ...other }: DashboardContentProps) {
  const { t } = useTranslate('account');

  const pathname = usePathname();

  const NAV_ITEMS = [
    {
      label: t('layout.tabs.general'),
      icon: <Iconify width={24} icon="solar:user-id-bold" />,
      href: paths.dashboard.user.account,
    },
    {
      label: t('layout.tabs.billing'),
      icon: <Iconify width={24} icon="solar:bill-list-bold" />,
      href: `${paths.dashboard.user.account}/billing`,
    },
    {
      label: t('layout.tabs.notifications'),
      icon: <Iconify width={24} icon="solar:bell-bing-bold" />,
      href: `${paths.dashboard.user.account}/notifications`,
    },
    {
      label: t('layout.tabs.socialLinks'),
      icon: <Iconify width={24} icon="solar:share-bold" />,
      href: `${paths.dashboard.user.account}/socials`,
    },
    {
      label: t('layout.tabs.security'),
      icon: <Iconify width={24} icon="ic:round-vpn-key" />,
      href: `${paths.dashboard.user.account}/change-password`,
    },
  ];

  return (
    <DashboardContent {...other}>
      <CustomBreadcrumbs
        heading={t('layout.breadcrumbs.account')}
        links={[
          { name: t('layout.breadcrumbs.dashboard'), href: paths.dashboard.root },
          { name: t('layout.breadcrumbs.user'), href: paths.dashboard.user.root },
          { name: t('layout.breadcrumbs.account') },
        ]}
        sx={{ mb: 3 }}
      />

      <Tabs value={removeLastSlash(pathname)} sx={{ mb: { xs: 3, md: 5 } }}>
        {NAV_ITEMS.map((tab) => (
          <Tab
            component={RouterLink}
            key={tab.href}
            label={tab.label}
            icon={tab.icon}
            value={tab.href}
            href={tab.href}
          />
        ))}
      </Tabs>

      {children}
    </DashboardContent>
  );
}
